import * as Common from '@/tenant/common';

export class PurchaseCashBalanceQuery extends Common.ReportQuery {
    constructor(){
        super("PurchaseCashBalanceQuery", null);
    }
    // public closingDate: Date = null;
    public startDate: Date = null;
    public endDate: Date = null;        
    public segment: Common.Segment = null;
    public currencyCode: string = null;
    public onExcelExport:boolean = false;           
}

export class PurchaseCashBalanceTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='PurchaseCashBalanceQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
